module.exports = __webpack_public_path__ + "img/background-img-5@2x.15d36316.png";